import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { glassCardSx, iconWrapSx } from './glassStyles';

interface GlassNotificationProps {
    accent: string;
    icon: ReactNode;
    title: string;
    subtitle?: string;
    children?: ReactNode;
}

/** A frosted-glass notification card with icon badge, title, and optional subtitle/children. */
export const GlassNotification: React.FC<GlassNotificationProps> = ({ accent, icon, title, subtitle, children }) => (
    <Box sx={glassCardSx(accent)}>
        <Box sx={iconWrapSx(accent)}>{icon}</Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" fontWeight={600}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                    {subtitle}
                </Typography>
            )}
            {children}
        </Box>
    </Box>
);
